<template>
    <v-card>
        <v-card-title>Copy Purchase Orders</v-card-title>
        <v-card-subtitle>Generate Landed Cost Lines from Purchase Orders</v-card-subtitle>
        <v-card-text>
            <v-form>
                <v-row>
                    <v-col>
                        <v-text-field
                            label="Code"
                            dense
                            hide-details="auto"
                            outlined
                            v-model="search.code"
                            clearable
                            />    
                    </v-col>
                </v-row>
            </v-form>
            <v-row>
                <v-col>
                    <v-data-table
                        dense
                        show-select
                        v-model="selected"
                        :headers="headers"
                        :items="data"
                        :page.sync="page"
                        :server-items-length="serverItemsLength"
                        :options.sync="options"
                        :loading="loading"
                        disable-sort
                        :footer-props="{'items-per-page-options': [10, 25, 50]}"
                        ></v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions>
            <v-row no-gutters>
                <v-col cols="12" md="6" class="pe-2">
                    <v-btn block color="primary" :disabled="!hasSelected" @click="handleSubmit">
                        Copy from <v-chip small class="mx-2 font-weight-bold">{{ selected.length }}</v-chip> Purchase Orders
                    </v-btn>
                </v-col>
                <v-col cols="12" md="6">
                    <v-btn block depressed @click="handleCancel">
                        cancel
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
import purchaseOrder from '../../services/purchase/order';

export default {
    props: {
        warehouseId: [String, Number]
    },
    data() {
        return {
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "State", value: "state" },
                { text: "Supplier", value: "supplier" }
            ],
            data: [],
            loading: false,
            page: 1,
            options: {},
            search: {
                code: null,
                warehouse_id: null
            },
            serverItemsLength: 0,
            selected: []
        }
    },
    computed: {
        hasSelected() {
            return this.selected.length > 0;
        }
    },
    watch: {
        options: {
            deep: true,
            handler() {
                this.fetch();
            }
        },
        search: {
            deep: true,
            handler() {
                this.handleSearch();
            }
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            purchaseOrder.index({...this.options, ...this.search, warehouse_id: this.warehouseId}).then(res => {
                this.data = res.data.data;
                this.serverItemsLength = res.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
        handleSearch() {
            this.page = 1;
            this.fetch();
        },
        handleSubmit() {
            this.$emit("submit", [...this.selected])
        },
        handleCancel() {
            this.$emit("cancel");
        }
    }
}
</script>

<style>

</style>